import React from 'react';
import Tooltip from '../../../../../ui/tooltip/Tooltip';
import { removeWordsFromText } from '../../../../../../utils/utils';
import classes from './SchoolNameCell.module.css';

const WORDS_TO_REMOVE = ['בית הספר', 'בית ספר','ביס'];

const SchoolNameCell = ({ value }) => {
  const originalText = String(value || '');
  const text = removeWordsFromText(originalText, WORDS_TO_REMOVE);

  return (
    <Tooltip text={originalText} showTooltip={true} className={classes.schoolNameCellTooltip}>
      <div className={classes.schoolNameCell}>
        {text}
      </div>
    </Tooltip>
  );
};

export default SchoolNameCell;
